export default __webpack_public_path__ + "static/media/expenditures_icon.b503afe2.svg";